export default function toBoolean(value: any) {
  if (['1', 1, true, 'true'].indexOf(value) > -1) {
    return true;
  } else if (['0', 0, false, 'false'].indexOf(value) > -1) {
    return false;
  }

  return undefined;
}
